import { adaptIncidents } from '@/app/pages/sports/football/match-details/adapters/incidents.adapter';
import { noPro } from '@/app/utils/constants';
import { computed, effect, inject } from '@angular/core';
import {
  IWsIncidentsApi,
  IWsMatch,
  IWsMatchesApi,
  IWsMatchesStatsApi,
  IWsMatchStats,
} from '../models';
import {
  handleGamePeriord,
  handleIncidensTeamGround,
  handleIncidentsKind,
  handleMatchKind,
  handleMatchStartTime,
  handleStatKind,
  handleStatMeasure,
} from '../utils/utils';
import { EEvent, WsMatchManagerService } from '../ws-match-manager';

const matchIdsTest = [
  // HT
  '3651b689-6db9-5107-b177-4aab1d4cb11f',
  // 'a2a0e203-d9e5-5c03-a14a-748565db472f',
  // '494bb3fe-f556-5726-ab4a-dd6b6771674f',
  // '3fbb3388-c8d7-5db3-92a8-1292445a08ef',
];

export function useWsMatchStats() {
  const manager = inject(WsMatchManagerService);
  const ctx = manager.getChannel(EEvent.STATS);

  effect(() => {
    ctx.connect();
  });

  const statsMatches = computed(() => {
    const raw = ctx.data() as IWsMatchesStatsApi;

    const originalMap = raw?.matchesStats?.matchStats ?? {};

    const adaptedMap: Record<string, IWsMatchStats> = {};

    for (const key in originalMap) {
      const match = originalMap[key];
      adaptedMap[key] = {
        id: key,
        stats: match.stats.map((stat) => ({
          awayValue: stat.awayValue,
          homeValue: stat.homeValue,
          id: stat.id,
          kind: handleStatKind(stat.kind),
          measure: handleStatMeasure(stat.measure),
        })),
      };
    }

    for (const matchId of matchIdsTest) {
      if (adaptedMap[matchId]) {
        console.log('stats:');
        console.log(adaptedMap[matchId]);
      }
    }

    if (noPro) {
      console.log({ adaptedMap });
    }
    return adaptedMap;
  });

  return {
    data: statsMatches,
    isConnected: ctx.isConnected,
    disconnect: ctx.disconnect,
  };
}

export function useWsMatchIncidents() {
  const manager = inject(WsMatchManagerService);
  const ctx = manager.getChannel(EEvent.INCIDENTS);

  effect(() => {
    ctx.connect();
  });

  const incidentsMatches = computed(() => {
    const raw = ctx.data() as IWsIncidentsApi;

    const originalMap = raw?.matchesIncidents?.matchIncidents ?? {};

    const adaptedMap: Record<string, any> = {};

    for (const key in originalMap) {
      const match = originalMap[key];
      const incidents = match.incidents.map((incident) => ({
        idMatchIncident: key,
        assistPlayer: incident.assistPlayer,
        substitutePlayer: incident.substitutePlayer,
        gamePeriod: handleGamePeriord(incident.gamePeriod),
        gameTime: incident.gameTime,
        id: incident.id,
        kind: handleIncidentsKind(incident.kind),
        order: incident.order,
        player: incident.player,
        teamGround: handleIncidensTeamGround(incident.teamGround),
        varResult: incident.varResult,
        awayScore: incident.awayScore,
        homeScore: incident.homeScore,
      }));

      adaptedMap[key] = {
        id: key,
        incidents: adaptIncidents(incidents),
      };
    }

    for (const matchId of matchIdsTest) {
      if (adaptedMap[matchId]) {
        console.log('incidents:');
        console.log(adaptedMap[matchId]);
      }
    }

    if (noPro) {
      console.log({ adaptedMap }, 'incidents');
    }
    return adaptedMap;
  });

  return {
    data: incidentsMatches,
    isConnected: ctx.isConnected,
    disconnect: ctx.disconnect,
  };
}

export function useWsMatchMatches() {
  const manager = inject(WsMatchManagerService);
  const ctx = manager.getChannel(EEvent.MATCHES);

  effect(() => {
    ctx.connect();
  });

  const matches = computed(() => {
    const raw = ctx.data() as IWsMatchesApi;

    const originalMap = raw?.mapMatches?.matches ?? {};

    const adaptedMap: Record<string, IWsMatch> = {};

    for (const key in originalMap) {
      const match = originalMap[key];
      adaptedMap[key] = {
        id: key,
        awayScore: match.awayScore,
        gamePeriod: handleGamePeriord(match.gamePeriod),
        gameTimeAdd: match.gameTimeAdd,
        halfAwayScore: match.halfAwayScore,
        halfHomeScore: match.halfHomeScore,
        penaltyAwayScore: match.penaltyAwayScore,
        penaltyHomeScore: match.penaltyHomeScore,
        homeScore: match.homeScore,
        isLive: match.isLive,
        periodStartTime: handleMatchStartTime(match.periodStartTime),
        state: handleMatchKind(match.state),
      };
    }

    for (const matchId of matchIdsTest) {
      if (adaptedMap[matchId]) {
        console.log({ adaptedMapMatches: adaptedMap[matchId] });
      }
    }

    if (noPro) {
      console.log({ adaptedMapMatches: adaptedMap });
    }
    return adaptedMap;
  });

  return {
    data: matches,
    isConnected: ctx.isConnected,
    disconnect: ctx.disconnect,
  };
}
